import BetOddsWrapper from './BetOddsWrapper';
import BetWrapper from './BetWrapper';
import OddWithDesc from './OddWithDesc';

export default function Bet(props) {
    const data = props.data;

    return (
        <BetWrapper data={data} toggled={props.toggled == null ? true : props.toggled}>
            <BetOddsWrapper>
                {data.odds.map(o =>
                    <OddWithDesc key={o.uniqueId} data={o} />
                )}
            </BetOddsWrapper>
        </BetWrapper>
    );
}
